module.exports = __webpack_public_path__ + "static/img/s-hw-3.b9a8e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-hw-3.png
// module id = 87aU
// module chunks = 0